// extracted by mini-css-extract-plugin
module.exports = {"BgImg":"CryptoPageLayer_BgImg__21JBN"};